import Head from 'next/head'

type Props = {
  title: string,
  description: string,
}

const OgTags = ({ title, description }: Props) =>
  <Head>
    <meta property='og:type' content='website' />
    <meta property='og:title' content={title} />
    <meta property='og:description' content={description} />
    <meta property='og:image' content='/static/images/blotter_og.png' />
  </Head>

export default OgTags
